import { concreteBaseService } from "Dashboard/scenes/ConcreteBase/services/concreteBase.service";
import { forwardRef, useEffect, useState } from "react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";

interface IConcreteBaseItemOption {
  label: string;
  value: number;
  code?: string;
  knownItemCodes: string[];
  unit?: string;
  pricePerUnit?: number
};

const ConcreteBaseItemSelectCreate = forwardRef<any, any>((props, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState<IConcreteBaseItemOption[]>([]);
  const [value, setValue] = useState<IConcreteBaseItemOption | undefined>(undefined);
  const [inputValue, setInputValue] = useState<string | undefined>(undefined);

  useEffect(() => {
    async function getData() {
      const items = await concreteBaseService.getConcreteBaseInputItems(props.isOwnProduct);
      const op = items.map((item) => {
        return {
          label: item.name,
          value: item.itemId,
          code: item.latestItemCode ? item.latestItemCode : undefined,
          knownItemCodes: item.knownItemCodes ? item.knownItemCodes : [],
          unit: item.latestQuantityUnit ? item.latestQuantityUnit.unitId : undefined,
          pricePerUnit: item.latestPricePerUnit ? item.latestPricePerUnit : undefined,
        };
      });
      setOptions(op);
      setIsLoading(false);
    }

    try {
      if (props.isOwnProduct !== null) {
        getData();
      }
    } catch (err) {
      console.log(err);
    }
  }, [props.isOwnProduct]);

  const handleChange = (newValue: any, actionMeta: any) => {
    setValue(newValue);
    props.onChange(newValue ? newValue.value : null);
    if (props.code !== undefined) {
      props.setValue(props.code, newValue ? newValue.code : "", {
        shouldValidate: false,
        shouldDirty: true,
      });
    }
    if (props.setKnownItemCodes !== undefined) {
      props.setKnownItemCodes(newValue ? newValue.knownItemCodes : []);
    }
    if (props.unit !== undefined) {
      props.setValue(props.unit, newValue ? newValue.unit : undefined, {
        shouldValidate: false,
        shouldDirty: true,
      });
    }
    if (props.pricePerUnit !== undefined) {
      props.setValue(props.pricePerUnit, newValue ? newValue.pricePerUnit : undefined, {
        shouldValidate: false,
        shouldDirty: true,
      });
    }
  };

  useEffect(() => {
    if (!isLoading) {
      const values = options.filter((o) => o.value === props.value);
      if (values[0]) {
        setValue(values[0]);
      } else {
        setValue(undefined);
      }
    }
  }, [options, props.value, isLoading]);

  const createOption = async (name: string): Promise<IConcreteBaseItemOption> => {
    try {
      const item = await concreteBaseService.createConcreteBaseInputItem({ itemName: name, isOwnProduct: props.isOwnProduct || false });
      return {
        label: item.name,
        value: item.itemId,
        code: item.latestItemCode ? item.latestItemCode : undefined,
        knownItemCodes: item.knownItemCodes ? item.knownItemCodes : [],
        unit: undefined,
        pricePerUnit: undefined
      };
    } catch (err) {
      throw err;
    }
  };

  const handleCreate = async (inputValue: any) => {
    try {
      setIsLoading(true);
      const newOption = await createOption(inputValue);
      setOptions([...options, newOption]);
      handleChange(newOption, null);
      setIsLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  const formatCreate = (inputValue: string) => {
    return <p> Dodaj: {inputValue}</p>;
  };

  return props.isOwnProduct
    ? (<Select
      styles={props.customStyles}
      menuPosition="fixed"
      ref={ref}
      isClearable
      placeholder={""}
      isDisabled={isLoading}
      isLoading={isLoading}
      onChange={handleChange}
      options={options}
      value={value}
      defaultValue={value}
      noOptionsMessage={() => "Ne postoji"}
      {...{ error: props.error }}
    />)
    : (
      <CreatableSelect
        styles={props.customStyles}
        menuPosition="fixed"
        ref={ref}
        isClearable
        placeholder={""}
        isDisabled={isLoading}
        isLoading={isLoading}
        onChange={handleChange}
        options={options}
        value={value}
        defaultValue={value}
        formatCreateLabel={formatCreate}
        onCreateOption={handleCreate}
        inputValue={props.preserveInput && inputValue}
        onInputChange={props.preserveInput &&
          ((newVal) => setInputValue(newVal))}
        onMenuOpen={props.preserveInput &&
          (() => setInputValue(value?.label))}
        onMenuClose={props.preserveInput &&
          (() => setInputValue(undefined))}
        {...{ error: props.error }}
      />
    );
});

export default ConcreteBaseItemSelectCreate;
